import { IsNotEmpty, IsInt, IsOptional, Validate, IsString, Length, Min, IsNumber, IsDateString } from "class-validator";
import { CustomIdDTO} from "../common/id-validator.dto";
import { Sim } from "../../sim";

export class CreateSimDTO {

    @IsNotEmpty()
    @IsString()
    @Length(3, 30)
    identifier: string;

    @IsNotEmpty()
    @IsDateString()
    expirationDate: Date;

    @IsNotEmpty()
    @IsInt()
    @Min(0)
    dataUsage: number;

    @IsNotEmpty()
    @IsInt()
    maxDataUsable: number;

    @IsNotEmpty()
    @IsString()
    @Length(1, 30)
    simOperator: string

    @IsNotEmpty()
    @IsNumber()
    monthlyFee : number;

    @IsOptional()
    @Validate(CustomIdDTO)
    box?: number | null;


    constructor(sim : Sim) {
        if (sim.identifier) this.identifier = sim.identifier;
        if (sim.expirationDate) this.expirationDate = sim.expirationDate;
        if (sim.dataUsage) this.dataUsage = sim.dataUsage;
        if (sim.maxDataUsable) this.maxDataUsable = sim.maxDataUsable;
        if (sim.simOperator) this.simOperator = sim.simOperator;
        if (sim.monthlyFee) this.monthlyFee = sim.monthlyFee;
        if (sim.box) this.box = sim.box.id;
    }
}

